import React from "react";

function Hero() {
    return (
        <div className="flex justify-center slide-down text-sm lg:text-5xl font-bold bg-[url('./Images/terrazo.webp')] rounded-xl">
            <div className=" text-white font-sourcecodepro py-16 px-8">
                A software engineer that enjoys implementing efficient and
                memorable experiences
            </div>
        </div>
    );
}

export default Hero;
